import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { getWalletManagementDetail } from '../cryptoWalletsEndpoints'

export function useWalletManagementDetailQuery(investorId: MaybeRefOrGetter<string>) {
  // Disabled until an id exists, so a direct navigation that has not resolved
  // its route param yet does not fire a request for `/investors/undefined`.
  const enabled = computed(() => Boolean(toValue(investorId)))

  return useQuery({
    queryKey: () => cryptoWalletsKeys.walletManagementDetail(toValue(investorId)),
    queryFn: () => getWalletManagementDetail(toValue(investorId)),
    enabled,
  })
}
